module.exports = __webpack_public_path__ + "media/images/brands/hapier-3fdcea888eb1b666d0661dcb201829fb.png";